import {
    ACTION_LIST_PRODUCTS,
    ACTION_DETAIL_PRODUCT,
    ACTION_LIST_PRODUCTS_CLIENT,
    ACTION_LIST_PRODUCTS_FILTER_TYPE_PRODUCT,
    ACTION_LIST_NUMBER_CONTRACT_FILTER_COMPANY,
    ACTION_POLICY_PRODUCT,
    ACTION_DIALOG_ACTIVE,

    ACTION_GET_PRODUCT_BY_ID,
    ACTION_GET_PRODUCTS,
    ACTION_POST_CREATE_PRODUCTS,
    ACTION_PUT_UPDATE_PRODUCTS,
    ACTION_DELETE_DELETE_PRODUCTS,
    ACTION_GET_LIST_COUNTRY,
    
    SET_PRODUCTS,
    SET_PRODUCT_BY_MODE,
    SET_DETAIL_PRODUCT,
    SET_PRODUCTS_CLIENT,
    SET_DIALOG_ACTIVE,
    SET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";

import { ProductsService } from "../../../services";

import config from "@/views/products/config/product_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';
import Swal from 'sweetalert2';


const _pathUri = new PathUri(config.port, config.context);

const actions = {

    [ACTION_LIST_PRODUCTS]: ({ state, commit }, supplierId) => {
        
        return new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'get',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/prov/`+ supplierId,
                headers: {
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                }
            })
                .then(async resp => {
                    const products = await resp.data.payload.map((e, i) => ({
                        ...e,
                        activeDialogProduct: false,
                        index: i
                    }));
                    commit(SET_PRODUCTS, products);
                    resolve()
                    
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },

    [ACTION_DIALOG_ACTIVE]: ({ commit }, data) => {
        commit(SET_DIALOG_ACTIVE, data);
    },

    [ACTION_DETAIL_PRODUCT]: ({ state, commit }, data) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'get',
                url: `${config.baseUrl + _pathUri.generateUri() + data.supplierId + '/prov/' + data.idProducto}`
            })
                .then(resp => {
                    const detailproduct = resp.data;
                    commit(SET_DETAIL_PRODUCT, detailproduct);
                    resolve()
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },
    
    [ACTION_LIST_PRODUCTS_CLIENT]: ({ state, commit }, idEmpresa) => {

        return new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'get',
                url: `${config.baseUrl + _pathUri.generateUri() + 'emp/' + idEmpresa}`
            })
                .then(resp => {
                    const productsClient = resp.data;
                    commit(SET_PRODUCTS_CLIENT, productsClient);
                    resolve()
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },

    [ACTION_LIST_PRODUCTS_FILTER_TYPE_PRODUCT]: (_, payload) => {

        const { idEmpresa, idTipoProducto } = payload;

        const uri = `${config.baseUrl}${_pathUri.generateUri()}`;
        const services = `empresa/${idEmpresa}/tipo_servicio/${idTipoProducto}`;

        return new Promise((resolve, reject) => {
            
            axios({
                method: 'get',
                url: uri + services
            })
                .then(resp => resolve(resp.data))
                .catch(err => reject(err))
        })
    },

    [ACTION_LIST_NUMBER_CONTRACT_FILTER_COMPANY]: (_, payload) => {
        const { idEmpresa, tipoContrato } = payload;
        const uri = `${config.baseUrl}${_pathUri.generateUri()}`;
        const services = `numero_contrato/empresa/${idEmpresa}/tipo_contrato/${tipoContrato}`;
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: uri + services
            })
                .then(resp => resolve(resp.data))
                .catch(err => reject(err))
        })
    },

    [ACTION_POLICY_PRODUCT]: (_, payload) => {

        const { idEmpresa, idProducto } = payload;

        const uri = `${config.baseUrl}${_pathUri.generateUri()}`;
        const services = `politica/empresa/${idEmpresa}/producto/${idProducto}`;

        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: uri + services
            })
                .then(resp => resolve(resp.data))
                .catch(err => reject(err))
        })
    },

    [ACTION_GET_PRODUCTS]: async ({ state, commit } ) => {
        return new Promise((resolve, reject) => {
            
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/productos/allProducts`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    
                    if (resp.data.payload && Array.isArray(resp.data.payload)) {
                        const products = resp.data.payload.map((e, i) => ({
                            ...e,
                            index: i
                        }));
                        
                        commit(SET_PRODUCTS, products);
                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de productos:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de productos:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_PRODUCTS]: async ({ state }, product) => {
         
        const formdata = new FormData();
        formdata.append("nombre", product.nombre);
        formdata.append("descripcion", product.descripcion);
        formdata.append("valorUnitarioCliente", product.valorUnitarioCliente);
        formdata.append("archivoDetalle", product.archivoDetalle);
        formdata.append("linkYoutube", product.linkYoutube);
        formdata.append("idModo", product.idModo);
        formdata.append("supplierId", product.supplierId);
        formdata.append("idTipoProducto", product.idSubCategoria);
        formdata.append("caracteristica1", product.caracteristica1);
        formdata.append("caracteristica2", product.caracteristica2);
        formdata.append("caracteristica3", product.caracteristica3);
        formdata.append("enlaceInformacion", product.enlaceInformacion);
        formdata.append("contacto", product.contacto);
        formdata.append("countryPhoneCodeId", product.countryPhoneCodeId);
        formdata.append("codProducto", product.codProducto);

        return await new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'post',
                url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")}/productos/create`,
                headers:{
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },
                data: formdata,
                redirect: 'follow'
            })
            .then(async(resp) => {
                // Agrega una condición para verificar si la respuesta fue exitosa
                if (resp && resp.status === 200) {
                    await Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'El Producto fue creado exitosamente',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);
                } else {
                    // Si la respuesta no es exitosa, puedes manejarlo aquí
                    reject("La petición fue incorrecta o falló");
                }
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => state.loading = false);
            
        });
    },

    [ACTION_PUT_UPDATE_PRODUCTS]: async ({ state }, product) => {
        const formdata = new FormData();
        
        return await new Promise((resolve, reject) => {
            formdata.append("idProducto", product.idProducto)
            formdata.append("nombre", product.nombre);
            formdata.append("descripcion", product.descripcion);
            formdata.append("valorUnitarioCliente", product.valorUnitarioCliente);
            formdata.append("archivoDetalle", product.archivoDetalle);
            formdata.append("linkYoutube", product.linkYoutube);
            formdata.append("idModo", product.idModo);
            formdata.append("supplierId", product.supplierId);
            formdata.append("idTipoProducto", product.idSubCategoria);
            formdata.append("caracteristica1", product.caracteristica1);
            formdata.append("caracteristica2", product.caracteristica2);
            formdata.append("caracteristica3", product.caracteristica3);
            formdata.append("enlaceInformacion", product.enlaceInformacion);
            formdata.append("contacto", product.contacto);
            formdata.append("countryPhoneCodeId", product.countryPhoneCodeId);
            formdata.append("codProducto", product.codProducto);
            
            state.loading = true;
            axios({
                method: 'put',
                url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")}/productos/update/`,
                headers:{
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },
                data: formdata,
                redirect: 'follow'
            })
            .then(async(resp) => {
                
                // Agrega una condición para verificar si la respuesta fue exitosa
                if (resp && resp.status === 200) {
                    
                    await Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'El Producto fue actualizado exitosamente',
                        showConfirmButton: false,
                        timer: 2500
                    });                    
                    
                    resolve(resp);
                } else {
                    // Si la respuesta no es exitosa, puedes manejarlo aquí
                    reject("La petición fue incorrecta o falló");
                }
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => state.loading = false);
        });
    },

    [ACTION_DELETE_DELETE_PRODUCTS]: async ({ state }, modoIdProducto) => {
        state.loading = true;
        return await new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'delete',
                url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")}/productos/delete/${modoIdProducto.idProducto}/modo/${modoIdProducto.idModo}`,
                headers:{
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },
                
                redirect: 'follow'
            })
            .then(async(resp) => {

                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'El producto fue eliminado exitosamente',
                    showConfirmButton: false,
                    timer: 2500
                });
                resolve(resp);
         
            })
            .catch(err => {
                reject(err);
            })
            .finally(() => state.loading = false);
        });
    },

    [ACTION_GET_PRODUCT_BY_ID]: async ({ state, commit }, modoIdProducto) => {
        return new Promise((resolve, reject) => {
            
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/productos/detailcore/${modoIdProducto.idProducto}/modo/${modoIdProducto.idModo}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                    
                })
                .then(resp => {
                    if (resp.data.payload) {
                        const products = resp.data.payload
                        commit(SET_PRODUCT_BY_MODE, products);
                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    console.error("Error en la solicitud de productos:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error("Error en la solicitud de productos:", error);
                reject(error);
            }
            finally {
                state.loading = false;
            }
        });
    },
    
    [ACTION_GET_LIST_COUNTRY]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
               state.loading = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
                ProductsService.getCountryPhoneCode(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const countryCode = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_LIST_COUNTRY, countryCode);
                            state.loading = false;
                            resolve(resp.data.payload);
                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                     //   state.loading = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
                
            }
        });
    },
    /*
    [ACTION_GET_LIST_COUNTRY]: async ({ state, commit}) => {


        return await new Promise((resolve, reject) => {

            state.loading = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");
     
            ProductsService.getCountryPhoneCode(idGroup, idEmpresa, idUsuario)
                .then(resp => {

                    const countryCode = resp.data.payload
                    commit(SET_LIST_COUNTRY, countryCode);
                    resolve(resp.data.payload);


                })
                .catch(err => {
                    console.error("Error en la solicitud de usuario:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
        })
    },*/

};

export default actions;
